import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {SelectionModel} from "@angular/cdk/collections";
import {VgApiService, VgMediaDirective} from "@videogular/ngx-videogular/core";
import {Router} from '@angular/router';
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {faBolt} from '@fortawesome/free-solid-svg-icons';
import {filter, map} from 'rxjs/operators';
import {combineLatest} from 'rxjs';
import {Compbaser} from "../../../components/compbaser";
import {basicTransition} from '../../../../libs/basicTransition';
import {IBlockLabelsRecords} from "../../editor/scene-blocks/block-constants";
import {IGroupCollection} from "../../../interfaces/enterprise-interface";
import {IAccessTable, IAppSettingsWrap, ICRUDCommand, ICRUDRecord, IPaintSource, IResource, IResourcePreview} from "../../../interfaces";
import {getResourcePreview, isNullOrUndefOrEmpty, PREVIOUSLY_USED_ACCOUNT, restrictSingleQuote} from "../../../common";
import {actionAddPaint, actionCRUDRecord, actionUpdateResources} from "../../../store/actions/user.actions";
import {AccessService, AppService, CommonService, ContainerService, LocalStoreService, StoreSelectorsService} from "../../../services";
import {DialogCategoryTreeComponent} from '../../../components/dialog-category-tree/dialog-category-tree.component';
import {Lib} from "../../../../libs/Lib";
import { DialogImageFullScreenComponent } from 'app/components/dialog-fullscreen-view/dialog-fullscreen-view.component';
import { DialogPopComponent } from 'app/components/dialog-pop/dialog-pop.component';

@Component({
    selector: 'app-resource-props',
    templateUrl: './resource-props.component.html',
    styleUrls: ['./resource-props.component.scss'],
    animations: [basicTransition]
})
export class ResourcePropsComponent extends Compbaser implements OnInit {

    @ViewChild('resourceCategory') resourceCategory: any;
    @ViewChild('resourceName') resourceName: any;
    @ViewChild('resourceAccessKey') resourceAccessKey: any;
    @ViewChild('media') videoPlayer: any;
    @Input() showToolbar = true;
    @Input() previewMode = false;
    @Input() minimized = false;

    @Input()
    set setSelectionModel(i_selectionModel) {
        if (!i_selectionModel) return;
        this.selectionModel = i_selectionModel;
        this.loadPreview();
        this.once = true;
    }

    @Output() updateSelection = new EventEmitter<any>();;

    stringJSPipeArgsRound = {toFloat: '2'};
    stringJSPipeArgs = {toDateFromTimestamp: ['MM/DD/YY H:mm']};
    faBolt = faBolt;
    m_svgPath = '';
    m_resourceType = '';
    m_playResource;
    m_imagePath = '';
    m_formatIcon;
    once = false;
    coreAppData: IAppSettingsWrap;
    selectionModel: SelectionModel<number>;
    selectedResource: IResource;
    selectedResources: IResource[];
    blockLabelRecords: IBlockLabelsRecords;
    vgAPI: VgApiService;
    accessConfig: IAccessTable;
    groupCollection: IGroupCollection;
    accessMask: Array<string> = [];
    categories = [];
    category = '';
    loading = false;
    accountInitialCopyResources;
    PREVIOUSLY_USED_ACCOUNT = PREVIOUSLY_USED_ACCOUNT;

    constructor(
        private storeSelector: StoreSelectorsService,
        private translocoService: TranslocoService,
        public override dialog: MatDialog,
        private router: Router,
        private accessService: AccessService,
        private containerService: ContainerService,
        private appService: AppService,
        private localStoreService: LocalStoreService,
        private commonService: CommonService
    ) {
        super(dialog);
        this.blockLabelRecords = this.storeSelector.blockLabels;
        this.cod(
            this.storeSelector.getUserAccessMask().subscribe((v) => {
                this.accessMask = v;
            })
        );
        this.cod(
            this.accessService.getGroupsTable('SignStudio Resources', "resources").subscribe((v) => {
                this.accessConfig = v;
            })
        );
        this.cod(
            this.accessService.getGroupsCollection("SignStudio Resources").pipe(map((value) => value)).subscribe((v) => {
                this.groupCollection = v;
            })
        );
        this.cod(
            this.storeSelector.getCoreData()
                .subscribe((i_coreData: IAppSettingsWrap) => this.coreAppData = i_coreData)
        );
        this.cod(
            this.containerService.getCategories().subscribe((i_categories) => {
                this.categories = i_categories ? i_categories : [];
            })
        );
    }

    ngOnInit() {
        this.accountInitialCopyResources = this.localStoreService.getStorageConfig().accountInitialCopyResources;
        this.cod(
            this.storeSelector.getLocalStoreUpdates()
                .subscribe((updates) => {
                    if (!updates) return;
                    this.accountInitialCopyResources = this.localStoreService.getStorageValConfig('accountInitialCopyResources');
                })
        );
    }

    loadPreview() {
        if (this.once) return;
        const resources$ = this.storeSelector.getResources();
        const changed$ = this.selectionModel.changed;
        this.cod(
            combineLatest([changed$, resources$]).pipe(
                map(([a, resourcesArray]) => {
                    return this.selectionModel.selected.map((v) => {
                        return resourcesArray.find((s) => s.resource_id === String(v));
                    }).filter((v) => !isNullOrUndefOrEmpty(v))
                })
            ).subscribe((value) => {
                this.loading = false;
                if (value.length === 0) {
                    this.selectedResource = null;
                    return this.selectedResources = null;
                }
                if (value.length === 1) {
                    this.selectedResource = value[0];
                    this.selectedResources = null;
                    if (!this.selectedResource) return;
                    const resourcePreview: IResourcePreview = getResourcePreview(this.selectedResource, this.coreAppData, false, -1, false);
                    this.m_formatIcon = resourcePreview.icon;
                    this.m_resourceType = resourcePreview.type;
                    this.m_imagePath = resourcePreview.url;
                    this.m_svgPath = resourcePreview.url;
                    this.m_playResource = resourcePreview.url;
                    this.category = this.selectedResource.tree_path || '';
                    if (this.m_resourceType === 'video') {
                        this.m_playResource = resourcePreview.videoUrl;
                        this.reloadVideo();
                    }
                    Lib.DevShow('Preview resource ' + resourcePreview.url);
                    return;
                }

                /** multiple resources **/
                this.selectedResource = null;
                this.selectedResources = value;

                /** get resource category for multi-selection **/
                let tempCategory = '';
                this.selectedResources.forEach((_res, ind) => {
                    if (ind === 0) {
                        tempCategory = _res.tree_path;
                    } else {
                        if (tempCategory != _res.tree_path) {
                            tempCategory = '';
                        }
                    }
                });
                this.category = tempCategory;
            })
        );
    }

    showFullScreenImage() {        
        var resourcePreview = getResourcePreview(this.selectedResource, this.coreAppData, false, -1, false);
        this.dialog.open(DialogImageFullScreenComponent, {
            height: '100vh',
            width: '100vw',
            panelClass: 'fullscreen-dialog',
            data: {url: resourcePreview.url}
        });
    }

    onDelete() {
        // if (!this.accessConfig?.del) return this.accessService.showNoAccess();
        // if (this.selectionModel.selected.length === 0) return;
        // const localRemText1 = this.translocoService.translate('general.areYouSure', {}, this.translocoService.getActiveLang());
        // const localRemText2 = this.translocoService.translate('general.resources', {}, this.translocoService.getActiveLang());
        // const dialogRef = this.dialog.open(DialogPopComponent, {
        //     width: '400px',
        //     data: {name: `${localRemText1} ${localRemText2}?`, showCancel: true}
        // });
        // dialogRef.afterClosed().subscribe((r) => {
        //     if (r) {
        //         this.removeResourcesUsedInScenes();
        //         this.removeResourcesUsedInCatalog();
        //         this.removeResourcesUsedInScheduler();
        //         this.removeResources();
        //         this.resetSelection();
        //     }
        // });
    }

    onDeselect() {
        this.selectionModel.clear();
    }

    async onEditResource() {
        const resourcePreview = getResourcePreview(this.selectedResource, this.coreAppData, false, -1, false);
        if (!this.selectedResource.resource_id || !resourcePreview) return;
        this.localStoreService.setStorageValConfig('paintEnabled', '1');
        // this.getMeta("https://oregon-signage-resources.s3-us-west-2.amazonaws.com/business595375/resources/109.svg", (err, img) => {
        //     console.log(img.naturalWidth, img.naturalHeight);
        // });
        let imageW = 500;
        let imageH = 500;
        if (resourcePreview.url) {
            try {
                const img = await Lib.getMeta(resourcePreview.url);
                imageW = img['naturalWidth'];
                imageH = img['naturalHeight'];
            } catch {
                console.log("image size error");
            }
        }
        this.cod(
            this.storeSelector.getPaints().subscribe((i_paints) => {
                if (i_paints) {
                    const i_paint = i_paints.find((p) => p.resource_id === this.selectedResource.resource_id);
                    if (i_paint) {
                        this.router.navigateByUrl(`/paint/edit/${i_paint.id}`);
                        return;
                    }
                }
                const newPainter = {
                    painter_name: this.selectedResource.resource_name ? this.selectedResource.resource_name : 'resource paint',
                    painter_data: null,
                    resource_id: this.selectedResource.resource_id,
                    width: `${imageW}`,
                    height: `${imageH}`,
                    tree_path: '',
                    created_at: Math.round(new Date().getTime() / 1000) + '',
                    updated_at: Math.round(new Date().getTime() / 1000) + ''
                };
                /** Add new painter */
                const saveRecord: ICRUDRecord = {
                    studioId: this.localStoreService.getStorageConfig().studioId,
                    command: 'add',
                    primary: 'painter_id',
                    table: 'painters',
                    body: newPainter,
                    id: null
                };
                this.appService.crudRecord(saveRecord).then((i_crudReply: ICRUDRecord) => {
                    /** important dont update store since server command failed **/
                    if (!i_crudReply.serverReply.status) return;
                    newPainter['id'] = String(i_crudReply.serverReply.id);
                    this.storeSelector.dispatch(actionAddPaint({
                        data: newPainter as IPaintSource
                    }));
                    this.router.navigateByUrl(`/paint/edit/${i_crudReply.serverReply.id}`);
                });
            })
        );
    }

    onPlayerReady(api) {
        this.vgAPI = api;
    }

    reloadVideo() {
        if (this.m_resourceType !== 'video' || !this.vgAPI) return;
        const vgMediaDirective: VgMediaDirective = (this.vgAPI.getDefaultMedia() as VgMediaDirective);
        if (vgMediaDirective) vgMediaDirective.loadMedia();
    }

    updateResourceProperty(v: string = null, key: string = null) {
        if (!this.accessConfig?.upd) return this.accessService.showNoAccess();
        
        const treePath = key === 'tree_path' ? v: this.category;
        
        /** In case multi-selection */
        if (this.selectedResources) {
            this.selectedResources.forEach((_res) => {
                const resourceId = String(_res.resource_id);
                this.crudResource('update', resourceId, {
                    tree_path: treePath,
                });

                this.storeSelector.dispatch(actionUpdateResources({
                    resourcesId: resourceId,
                    access_key: _res.access_key,
                    tree_path: treePath,
                    resource_name: _res.resource_name
                }));
            });
            return;
        }

        /** In case single-selection */
        if (this.selectedResource) {
            const resourceName = restrictSingleQuote(this.resourceName.nativeElement.value);
            const isUpdatedName = this.selectedResource && this.selectedResource.resource_name !== resourceName;

            this.crudResource('update', String(this.selectionModel.selected[0]), {
                access_key: this.resourceAccessKey.value,
                tree_path: treePath,
                resource_name: resourceName
            });

            this.storeSelector.dispatch(actionUpdateResources({
                resourcesId: String(this.selectionModel.selected[0]),
                access_key: this.resourceAccessKey.value,
                tree_path: treePath,
                resource_name: resourceName
            }));

            if (isUpdatedName) {
                // update scheduler event value with new resource name
                this.commonService.updateScheduleEventValue('resource', [String(this.selectionModel.selected[0])], resourceName);
            }
        }
    }

    toggleSelection(resourceId) {
        this.selectionModel.toggle(resourceId);
        this.updateSelection.emit(this.selectionModel);
    }


    openCategoryTree() {
        this.dialog.open(DialogCategoryTreeComponent, {
            width: '500px',
            data: {
                categories: this.categories,
                treePath: this.category,
                callback: (treePath: string) => {
                    this.updateResourceProperty(treePath, 'tree_path');
                }
            }
        });
    }

    private crudResource(command: ICRUDCommand, id, body) {
        this.storeSelector.dispatch(actionCRUDRecord({
            saveRecord: {
                studioId: this.localStoreService.getStorageConfig().studioId,
                command,
                primary: 'resource_id',
                table: 'resources',
                body,
                id
            }
        }));
    }
}

// scenes: IScenePlayer[];
// resources: IResource[];
// @ViewChild('', {static: false}) videoPlayer;
// @ViewChild('matVideoComponent', {static: false})
// public videoElement: ElementRef;
// @ViewChild('video', {static: true}) matVideo: MatVideoComponent;
// video: HTMLVideoElement;
// @ViewChild('matVideoComponent', {static: false}) set elemOnHTML(elemOnHTML: ElementRef) {
//     if (!!elemOnHTML) {
//         this.elem = elemOnHTML;
//     }
// }


// private removeResourcesInPlaylists(playerSceneData: ISceneTreeSliceResults, resourceId: Id) {
//     const components: ICommon = _.cloneDeep(playerSceneData.sceneItem.Data["0"]);
//     _.remove(components.Playlist[0].Page, (v: IPage) => {
//         if (v.$.type !== 'resource') return;
//         return v.Player[0].Data[0].Resource[0].$.resource === resourceId;
//     });
//
//     this.storeSelector.dispatch(actionUpdateSceneItem({
//         sceneId: playerSceneData.sceneId,
//         sceneItemId: playerSceneData.sceneItem.$.id,
//         values: [{
//             key: 'Page',
//             value: components.Playlist[0].Page,
//             storePath: `Data[0].Playlist[0]`
//         }],
//         disableCRUD: true
//     }));
//     this.storeSelector.dispatch({type: 'BREAK_MERGE'});
// }

// private removeResourcesInLocation(playerSceneData: ISceneTreeSliceResults, resourceId: Id, slice: 'GPS' | 'Fixed'): boolean {
//     const components: ICommon = _.cloneDeep(playerSceneData.sceneItem.Data["0"]);
//     try {
//         /* 2-18-2023 if no such path and crashes, return true to exit */
//         const test = components.LocationBased[0][slice][0].Page;
//     } catch (e) {
//         return true;
//     }
//     _.remove(components.LocationBased[0][slice][0].Page, (v: IPager) => {
//         if (_.isEmpty(v)) return true;
//         if (v.$.type !== 'resource') return false;
//         return v.Player[0].Data[0].Resource[0].$.resource === resourceId;
//     });
//     const storePath = `Data[0].LocationBased[0][${slice}][0]`;
//     const value = components.LocationBased[0][slice][0]['Page'];
//     this.storeSelector.dispatch(actionUpdateSceneItem({
//         sceneId: playerSceneData.sceneId,
//         sceneItemId: playerSceneData.sceneItem.$.id,
//         values: [{
//             key: 'Page',
//             value,
//             storePath
//         }],
//         disableCRUD: true
//     }));
//     this.storeSelector.dispatch({type: 'BREAK_MERGE'});
// }

// private resetSelection() {
//     this.selectionModel.clear();
// }

// deselectItems() {
//     this.selectionModel.clear();
//// this.deselecting.next(null);
// }

// changedMask(value) {
//// console.log(value);
// }

// private removeResources() {
//     const resourceIds = this.selectionModel.selected.map((i_resourceId) => String(i_resourceId));
//     this.storeSelector.dispatch(actionRemoveResources({resourceIds}));
//     this.crudResource('delete', resourceIds, null);
// }

// private removeResourcesUsedInCatalog() {
//     /** Update catalog items about removed resources */
//     const removeItems = this.selectionModel.selected.map((resourceId) => ({
//         catalog_item_resource_id: null,
//         catalog_item_id: null,
//         resource_id: String(resourceId)
//     }));
//     this.storeSelector.dispatch(actionRemoveCatalogResource(
//         {catalogItemResources: removeItems})
//     );
//
//     /** Update store */
//     const removeIds = removeItems.map((v) => v.resource_id);
//     this.storeSelector.dispatch(actionCRUDRecord({
//         saveRecord: {
//             studioId: this.localStoreService.getStorageConfig().studioId,
//             command: 'delete',
//             primary: 'catalog_item_resource_id',
//             table: 'catalog_item_resources',
//             body: null,
//             id: removeIds
//         }
//     }));
// }

// private removeResourcesUsedInScheduler() {
//     /** remove resource schedule event */
//     const resourceIds = this.selectionModel.selected.map((resourceId) => String(resourceId));
//     this.commonService.removeScheduleEventsBySources('resource', resourceIds);
// }

// private removeResourcesUsedInScenes() {
//     const updatedSceneIds: Id[] = [];
//     this.selectionModel.selected.forEach((resourceId) => {
//         const scenes: IScenePlayer[] = this.scenes;
//         const searchResourceResult: ISceneTreeSearchResult[] = getPlayerIdsOfResourceId(scenes, String(resourceId));
//
//         searchResourceResult.forEach((v) => {
//             let sceneData;
//
//             if (v.lastPlaylistId) {
//                 sceneData = getPlayerIdInScene(scenes, v.sceneId, v.lastPlaylistId);
//                 this.removeResourcesInPlaylists(sceneData, String(resourceId));
//             }
//             if (v.lastLocationId) {
//                 sceneData = getPlayerIdInScene(scenes, v.sceneId, v.lastLocationId);
//                 this.removeResourcesInLocation(sceneData, String(resourceId), 'GPS');
//                 this.removeResourcesInLocation(sceneData, String(resourceId), 'Fixed');
//             }
//             if (!v.lastLocationId && !v.lastPlaylistId && v.lastImageId) {
//                 sceneData = getPlayerIdInScene(scenes, v.sceneId, v.lastImageId);
//
//                 // remove image/svg/video components from scene
//                 this.storeSelector.dispatch(actionRemoveSceneBlocks({
//                     sceneId: sceneData.sceneId,
//                     sceneItemId: null,
//                     values: [{
//                         key: null,
//                         value: sceneData.sceneItem.$.id,
//                         storePath: 'Data[0].Scene[0].Players[0].Player'
//                     }],
//                     disableCRUD: true
//                 }));
//                 this.storeSelector.dispatch({type: 'BREAK_MERGE'});
//             }
//             if (!sceneData) {
//                 this.storeSelector.dispatch(actionRemoveSceneBlocks({
//                         sceneId: v.sceneId,
//                         sceneItemId: null,
//                         values: [{
//                             key: null,
//                             value: v.sceneItemId,
//                             storePath: 'Data[0].Scene[0].Players[0].Player'
//                         }],
//                         disableCRUD: true
//                     })
//                 );
//             }
//
//             if (updatedSceneIds.indexOf(String(v.sceneId)) === -1) {
//                 updatedSceneIds.push(String(v.sceneId));
//             }
//         });
//     });
//
//     this.appService.updateMultiScene(updatedSceneIds);
// }

// onDelete() {
//     if (!this.accessConfig?.del) return this.accessService.showNoAccess();
//     if (this.selectionModel.selected.length === 0) return;
//     const localRemText1 = this.translocoService.translate('general.areYouSure', {}, this.translocoService.getActiveLang());
//     const localRemText2 = this.translocoService.translate('general.resources', {}, this.translocoService.getActiveLang());
//     const dialogRef = this.dialog.open(DialogPopComponent, {
//         height: '200px',
//         width: '400px',
//         data: {name: `${localRemText1} ${this.selectionModel.selected.length} ${localRemText2}?`, showCancel: true}
//     });
//     dialogRef.afterClosed().subscribe((r) => {
//         if (r) {
//             this.removeResourcesUsedInScenes();
//             this.removeResourcesUsedInCatalog();
//             this.removeResourcesUsedInScheduler();
//             this.removeResources();
//             this.resetSelection();
//         }
//     });
// }

// onEditResource() {
//     if (this.selectionModel.selected.length !== 1) return;
//
//     if (!this.selectedResource) return;
//     if (!checkImageType(this.selectedResource?.resource_type)) return;
//     this.loading = true;
//
//     this.selectionModel.selected.forEach((i_resourceId) => {
//         this.cod(
//             this.storeSelector.getPaints().subscribe((i_paints) => {
//                 if (i_paints) {
//
//                     const i_paint = i_paints.find((p) => p.resource_id === String(i_resourceId));
//                     if (i_paint) {
//                         setTimeout(() => {
//                             this.loading = false;
//                             this.router.navigateByUrl(`/paint/edit/${i_paint.id}`);
//                         }, 500);
//                         return;
//                     }
//                 }
//
//                 const imgWidth = parseInt(this.selectedResource.resource_pixel_width, 0);
//                 const imgHeight = parseInt(this.selectedResource.resource_pixel_height, 0);
//
//                 const newPainter = {
//                     painter_name: this.selectedResource.resource_name,
//                     painter_data: null,
//                     resource_id: String(i_resourceId),
//                     width: imgWidth > 0 ? this.selectedResource.resource_pixel_width : '500',
//                     height: imgHeight > 0 ? this.selectedResource.resource_pixel_height : '500',
//                     tree_path: '',
//                     created_at: Math.round(new Date().getTime() / 1000) + '',
//                     updated_at: Math.round(new Date().getTime() / 1000) + ''
//                 };
//
//                 /** Add new painter */
//                 const saveRecord: ICRUDRecord = {
//                     studioId: this.localStoreService.getStorageConfig().studioId,
//                     command: 'add',
//                     primary: 'painter_id',
//                     table: 'painters',
//                     body: newPainter,
//                     id: null
//                 };
//                 this.appService.crudRecord(saveRecord).then((i_crudReply: ICRUDRecord) => {
//                     /** important dont update store since server command failed **/
//                     //
//
//                     if (!i_crudReply.serverReply.status) {
//                         this.loading = false;
//                         return;
//                     }
//
//                     newPainter['id'] = String(i_crudReply.serverReply.id);
//
//                     this.storeSelector.dispatch(actionAddPaint({
//                         data: newPainter as IPaintSource
//                     }));
//
//                     setTimeout(() => {
//                         this.loading = false;
//                         this.router.navigateByUrl(`/paint/edit/${i_crudReply.serverReply.id}`);
//                     }, 500);
//                 });
//             })
//         );
//     });
// }
// this.cod(
//     this.storeSelector.getResources()
//         .subscribe((r) => {
//             this.resources = r;
//         })
// );
